export type ErrorCode = {
  code?: number | string;
};

export const DEFAULT_ERROR_CODE = 'default';

export const HTTP_STATUS = {
  ACCEPTED: 202,
  BAD_REQUEST: 400,
  CREATED: 201,
  FORBIDDEN: 403,
  NO_CONTENT: 204,
  NOT_FOUND: 404,
  OK: 200,
  REDIRECT: 302,
  SERVICE_UNAVAILABLE: 503,
  UNAUTHORIZED: 401,
};
